import { render, staticRenderFns } from "./BalanceChargeForm.vue?vue&type=template&id=763bd0ef"
import script from "./BalanceChargeForm.vue?vue&type=script&lang=js"
export * from "./BalanceChargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports